(function () {
  var timer = null;
  function place(ul, items, node, idx) {
    if (!node || items.length <= idx) return;
    items[idx - 1].insertAdjacentElement('afterend', node.cloneNode(true));
  }
  function run() {
    var tpl = document.querySelector('template[data-lts-breaks]');
    var ul = document.getElementById('product-grid');
    if (!tpl || !ul) return;
    ul.querySelectorAll('.lts-brk').forEach(function (n) { n.remove(); });
    var items = Array.prototype.filter.call(ul.children, function (c) { return c.classList.contains('flex-grid__item'); });
    if (items.length < 3) return;
    var w = items[0].getBoundingClientRect().width;
    if (!w) return;
    var cols = Math.max(1, Math.round(ul.getBoundingClientRect().width / w));
    var frag = tpl.content;
    place(ul, items, frag.querySelector('[data-brk="inspo"]'), cols * 2);
    place(ul, items, frag.querySelector('[data-brk="nudge"]'), cols * 4);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 150); }
  function init() {
    run();
    var host = document.querySelector('[id$="__product-grid"]') || document.getElementById('MainContent');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var ul = document.getElementById('product-grid');
        if (ul && !ul.querySelector('.lts-brk')) schedule();
      }).observe(host, { childList: true, subtree: true });
    }
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (Math.abs(window.innerWidth - lastW) > 40) { lastW = window.innerWidth; schedule(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
